import { Checkbox, Container, ContainerGutter, ContainerPadding, CTA, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { InputError, LastNavigation } from 'src/components';
import icon from 'src/components/img/icon-tick-blue.svg';
import { LayoutTemplate } from 'src/feature-app';

export const UGCConfirmacion = () => {
	const { register, errors } = useFormContext();

	const politicaDePrivacidadCTA = <CTA
		tag="a"
		target="_blank"
		href="https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html"
		emphasis="tertiary"
	>Política de Privacidad</CTA>;

	const atencionClienteCTA = <CTA
		tag="a"
		href="mailto:atencioncliente@volkswagen.es"
		emphasis="tertiary"
	>atencioncliente@volkswagen.es</CTA>;

	return (
		<LayoutTemplate element={
			<>
				<Container horizontalAlign="center" padding={{top: ContainerPadding.dynamic0050}}>
					<img src={icon} alt="icon" />
				</Container>

				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					¿Lo tienes <Text bold> todo listo?</Text>
				</Text>

				<Container wrap="always" padding={{top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100}}>
					<Container>
						<Checkbox
							label={
							<>
								<Text>Acepto la {politicaDePrivacidadCTA} de Volkswagen Group España Distribución.</Text>
							</>
							}
							value="true"
							name="privacidad"
							ref={(ref) => {
								register(ref, { required: true });
							}}
						/>
					</Container>
					<Container>
						{errors['privacidad'] ? <InputError className="error-field">Este campo es obligatorio</InputError> : null}
					</Container>
				</Container>

				<Container wrap="always" padding={{bottom: ContainerPadding.dynamic0100}}>
					<Container>
						<Checkbox
							label={
							<>
								<Text>Acepto y autorizo la cesión a Volkswagen Group España Distribución de mis derechos de imagen de acuerdo con la finalidad número 2 / cláusula nº 10 del apartado B modelo de concesión recogida en la {politicaDePrivacidadCTA} de Volkswagen Group España Distribución.</Text>
							</>
							}
							value="true"
							name="derechosImagen"
							ref={(ref) => {
								register(ref, { required: true });
							}}
						/>
					</Container>
					<Container>
						{errors['derechosImagen'] ? <InputError className="error-field">Este campo es obligatorio</InputError> : null}
					</Container>
				</Container>

				<LastNavigation KoTitle="Uy, algo ha pasado" KoBody="Por alguna razón no hemos podido guardar tu respuesta. ¿Lo intentamos de nuevo?" loadingCopy="Enviando tu petición" />

				<Container gutter={ContainerGutter.static300} wrap={'always'} padding={{top: ContainerPadding.dynamic0300}}>
					<Text bold staticSize appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Texto legal de Volkswagen
					</Text>
					<Text staticSize appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
						Sus datos serán tratados por Volkswagen Group España Distribución, S.A.U., en calidad de responsable del tratamiento, con la finalidad de recopilar y utilizar la historia que nos envíe acerca de su experiencia con un coche Volkswagen para promover nuestra marca, así como para contactar con usted para obtener más detalles sobre su historia. Puede ejercer sus derechos de protección de datos enviando un correo a {atencionClienteCTA} y obtener más información sobre el tratamiento de sus datos en la {politicaDePrivacidadCTA} de la web.
					</Text>
				</Container>
			</>
		}
		/>
	);
};
